import script from "./FicheArticleView.vue?vue&type=script&setup=true&lang=js"
export * from "./FicheArticleView.vue?vue&type=script&setup=true&lang=js"

import "./FicheArticleView.vue?vue&type=style&index=0&id=7ea88fd5&lang=scss"

const __exports__ = script;

export default __exports__